import { createAsyncThunk } from '@reduxjs/toolkit'
import { DeletedOverlay, Overlay, OverlayInit } from 'common/api/v1/types'
import { ThunkApi } from '../../store'
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from './notificationActions'
import { OverlaysRequestParams } from '../../api/nm-types'

export const listOverlays = createAsyncThunk<{ total: number; items: Overlay[] }, OverlaysRequestParams, ThunkApi>(
  'overlays/listOverlays',
  async (params, { extra: { api } }) => {
    return await api.overlaysApi.listOverlays(params)
  },
)

export const getOverlay = createAsyncThunk<Overlay, string, ThunkApi>(
  'overlays/getOverlay',
  async (id, { dispatch, extra: { api } }) => {
    try {
      return await api.overlaysApi.getOverlay(id)
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'get overlay' }))
      throw error
    }
  },
)

export const createOverlay = createAsyncThunk<Overlay, OverlayInit, ThunkApi>(
  'overlays/createOverlay',
  async (overlay, { dispatch, extra: { api } }) => {
    try {
      const res = await api.overlaysApi.createOverlay(overlay)
      dispatch(enqueueSuccessSnackbar('Overlay created'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'create overlay' }))
      throw error
    }
  },
)

export const updateOverlay = createAsyncThunk<Overlay, Overlay, ThunkApi>(
  'overlays/updateOverlay',
  async (overlay, { dispatch, extra: { api } }) => {
    try {
      const res = await api.overlaysApi.updateOverlay(overlay)
      dispatch(enqueueSuccessSnackbar('Overlay saved'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'update overlay' }))
      throw error
    }
  },
)

export const deleteOverlay = createAsyncThunk<DeletedOverlay, string, ThunkApi>(
  'overlays/deleteOverlay',
  async (id, { dispatch, extra: { api } }) => {
    try {
      const res = await api.overlaysApi.deleteOverlay(id)
      dispatch(enqueueSuccessSnackbar('Overlay deleted'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'delete overlay' }))
      throw error
    }
  },
)

export const deleteOverlays = createAsyncThunk<string[], string[], ThunkApi>(
  'overlays/deleteOverlays',
  async (ids, { dispatch, extra: { api } }) => {
    try {
      for (const id of ids) {
        await api.overlaysApi.deleteOverlay(id)
      }
      dispatch(enqueueSuccessSnackbar(`${ids.length} overlay${ids.length > 1 ? 's' : ''} deleted`))
      return ids
    } catch (err) {
      dispatch(enqueueErrorSnackbar({ error: err, operation: 'delete overlays' }))
      throw err
    }
  },
)
